var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GNavBar'),_c('h1',{staticClass:"mt-5 pt-5"},[_vm._v("CourseDev")]),_c('hr'),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"md":"12"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('keep-alive',[_c(_vm.currentDisplayComp,{tag:"component"})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }